import { Directive, HostListener } from "@angular/core";
import { GridComponent } from "@syncfusion/ej2-angular-grids";

@Directive({
    selector: "[ofiOneClickEdit]",
    standalone: false
})
export class OfiOneClickEditDirective {
  constructor(private _grid: GridComponent) {}

  @HostListener("mousedown", ["$event"]) onMouseDown(e: MouseEvent): void {
    if ((e.target as HTMLElement).classList.contains("e-rowcell")) {
      if (this._grid.isEdit) {
        this._grid.endEdit();
      }
      const index: number = +(e.target as HTMLElement).getAttribute("Index");
      this._grid.selectRow(index);
      this._grid.startEdit();
    }
  }
}
